import styled from 'styled-components';
import { Modal } from 'reactstrap';

export const ModalStyled = styled(Modal)`
  max-width: 900px;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  min-height: 572px;
  & > svg {
    margin: auto;
  }
  & > button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
  }
`;

export const TemplateSidebar = styled.div`
  background-color: #faf9f6;
  border-right: 1px solid ${({ theme }) => theme.colors.border.default};
  padding: 16px 24px;
  width: 237px;
  ul {
    list-style-type: none;
    margin: 16px 0 0 0;
    padding: 0;
    li {
      padding: 8px 6px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      :hover {
        background-color: #efeeea;
      }
      span {
        font-size: 18px;
      }
    }
  }
`;

export const TemplateCategory = styled.li`
  padding: 8px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? '#efeeea' : 'transparent')};
  :hover {
    background-color: #efeeea;
  }
  span {
    font-size: 18px;
  }
`;

export const TemplateContent = styled.div`
  padding: 28px;
  flex: 1;
  display: flex;
  flex-direction: column;
  & > h2 {
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }
  & > main {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
    margin-top: 30px;
  }
`;

export const TemplateCard = styled.div`
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.colors.brand.light.base : theme.colors.border.default};
  padding: 10px 12px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: ${({ isActive }) => (isActive ? '#EAFFEA' : 'transparent')};
  &:hover {
    background-color: #eaffea;
    border: 1px solid ${({ theme }) => theme.colors.brand.light.base};
  }
  & > span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const TemplateActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
`;
